<template>
  <div class="waterfall-height-css" id="loadmore">
    <Swipe style="padding: 65px 15px 10px;" :Banner="banners" v-if="banners.length!=0" />
    <div class="water">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="-----我们是有底线的-----"
        @load="onLoad"
      >
        <Waterfall
          :minCol="2"
          :maxCol="2"
          :percent="[1,1]"
          :gutterHeight="10"
          :width="itemWidth"
          :gutterWidth="gutterWidth"
        >
          <div
            class="margin"
            v-for="(item,index) in dataList"
            :key="index"
            :class="{'toMargin':item.type=='water'}"
          >
            <div class="item-content" @click="toComodity(item)">
              <div class="item-block" :class="{'noMargin':item.type=='water'}">
                <van-image :src="funImg(item)" fit="cover" lazy-load :show-loading="false" />
              </div>
              <div
                class="card-content van-multi-ellipsis--l2"
                v-show="item.type!='water'"
              >{{item.itemName}}</div>
              <div class="card-footer" v-show="item.type!='water'">
                <p class="color">￥{{item.price}}</p>
                <p class="color-cc">￥{{item.markingPrice}}</p>
              </div>
            </div>
            <div
              class="footer van-hairline--top"
              @click="toBrand(item.branchNo)"
              v-show="item.type!='water'"
            >
              <img src="@/assets/image/shop.png" />
              <p class="van-ellipsis">{{item.branchName}}</p>
            </div>
          </div>
        </Waterfall>
      </van-list>
    </div>
  </div>
</template>
<script>
import { Waterfall } from "vue2-waterfall";
import Swipe from "@/components/header/componets/iconswipe";
import http from "@/utils/axios";
import utils from "@/utils/common";
import { isWeChatApplet } from "@/utils/util";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      banners: [],
      activity: {},
      dataList: [],
      goodsidList: [],
      pageIndex: 1,
      pageSize: 10
    };
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  },
  components: { Waterfall, Swipe },
  created() {
    if (this.$route.query.iconid) {
      this.onIconDetailBanner();
    }
  },
  methods: {
    onIconDetailBanner() {
      http({
        url: "order/app/homepage/icon/iconBanner/" + this.$route.query.iconid,
        method: "post"
      }).then(rps => {
        if (rps.code === 200) {
          document.title = "商品分类";
          this.banners = rps.data;
        }
      });
    },
    onIconDetailData() {
      http({
        url: "order/app/homepage/icon/iconCategoryGoodsPage",
        method: "post",
        parmes: {
          iconId: this.$route.query.iconid,
          goodsIdList: this.goodsidList
        }
      }).then(rps => {
        if (rps.code === 200) {
          this.loading = false;
          //是否是最后一页
          if (rps.data.length == 0) {
            this.finished = true;
          } else {
            this.pageIndex++;
            this.dataList = this.dataList.concat(rps.data);
            let goodsidList = rps.data.map(item=>item.id)
            this.goodsidList = this.goodsidList.concat(goodsidList)
          }
          this.$loading.hide();
        }
      });
    },
    async toComodity(item) {
      if (item.type == "water") {
        if (item.waterLinkType === "BRANCH") {
          this.toBrand(item.waterLinkId);
        } else if (item.waterLinkValue && item.waterLinkType === "LINK") {
          utils.jumpUrl(item.waterLinkValue);
        } else if (item.waterLinkType === "SHOP") {
          this.$router.push({
            path: "/markentindex",
            query: { id: item.waterLinkId }
          });
        } else if (item.waterLinkType === "GOODS") {
          let parmes = {
            id: item.waterLinkId
          };
          this.gioFun(parmes);
          if (await isWeChatApplet()) {
            // this.$router.push({
            //   path: "/commoditydetails",
            //   query: { id: item.waterLinkId }
            // });
            var  obj = {goodsId:parseInt(item.waterLinkId)};
          utils.jumpToNewPage({
            url: location.origin + "/h5user/commoditydetails?id=" + item.waterLinkId,
            noTitle: "0",
            action:{tm:"4030100",tp:obj}
          });
          } else {
            wx.miniProgram.navigateTo({
              url:
                "/product/pages/product-detail/index?productid=" +
                item.waterLinkId
            });
          }
        }
      } else {
        let parmes = {
          id: item.id
        };
        this.gioFun(parmes);
        if (await isWeChatApplet()) {
          // this.$router.push({
          //   path: "/commoditydetails",
          //   query: { id: item.id }
          // });
          var obj = {goodsId:parseInt(item.id)};
         utils.jumpToNewPage({
            url: location.origin + "/h5user/commoditydetails?id=" + item.id,
            noTitle: "0",
            action:{tm:"4030100",tp:obj}
          });

        } else {
          wx.miniProgram.navigateTo({
            url: "/product/pages/product-detail/index?productid=" + item.id
          });
        }
      }
    },
    onLoad() {
      if (this.$route.query.iconid) {
        this.onIconDetailData();
      }
    },
    funImg(item) {
      if (item.indexImage && item.indexImage.imageUrl) {
        return (
          item.indexImage.imageUrl + "?x-oss-process=style/style_index_list_img"
        );
      }
    },
    async toBrand(id) {
      if (await isWeChatApplet()) {
        utils.jumpToNewPage({
          url: window.location.origin +'/h5user/brandindex?id=' + id,
          noTitle: '1',
          action:{tm:"4090100",tp:{branchId:parseInt(id)}}
        });
      } else {
        wx.miniProgram.navigateTo({
          url: "/product/pages/store-detail/index?storeid=" + id
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.waterfall-height-css {
  // border: 1px solid rgba(242, 242, 242, 1);
  padding: 20px 0;
  min-height: 1334px;
  .water {
    padding: 0 20px;
  }
  .toMargin {
    margin-bottom: 20px !important;
    border: 0 !important;
  }
  .margin {
    margin: 10px 10px 20px 10px;
    border-radius: 10px;
    border: 1px solid #f2f2f2;
    background-color: #fff;
    .noMargin {
      margin-bottom: 0 !important;
    }
  }
  .item-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #686868;
    box-sizing: border-box;
    .item-block {
      border: none;
      border-radius: 0.1rem;
      overflow: hidden;
      position: relative;
      margin: 0 0 10px 0;
      background-color: #fff;
      width: 100%;
      max-height: 400px;
      .van-image {
        position: initial;
      }
      img {
        width: 100%;
      }
    }
    .card-content {
      padding: 0 20px;
      width: 100%;
      box-sizing: border-box;
      font-size: 26px;
    }
    .card-footer {
      min-height: 44px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 10px 20px;
      .color {
        color: #e83636;
        font-size: 26px;
      }
      .color-cc {
        color: #ccc;
        font-size: 26px;
        text-decoration: line-through;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    padding-top: 24px;
    img {
      width: 32px;
      height: 32px;
      padding: 0 10px 0 20px;
    }
    p {
      color: #999;
      flex: 1;
      font-size: 22px;
    }
  }
}
</style>